const departments = {
    leader: '負責人',
    leaders: '部門負責人',
    led_departments: '負責的部門',
    edit_leaders: '設定負責人',
    add_leader: '新增',
    remove_leader: '移除',
    no_leaders: '未設定負責人',
    local: '本機設定',
    managed_members: '管理範圍內成員',
    leader_scope_hint: '僅可管理負責部門及子部門的成員歸屬。',
    leader_permission_hint: '負責人可管理本部門及子部門的成員歸屬，不能修改組織角色或部門結構。',
    primary_synced: '主部門由飛書同步維護。',
    status_active: '在職',
    status_suspended: '已凍結',
    status_departed: '已離職',
    status_pending: '待啟用',
    search: '搜尋',
    previous_page: '上一頁',
    next_page: '下一頁',
    directory_title: '組織成員',
    member_name: '成員',
    search_members: '依姓名或使用者名稱搜尋',
    include_descendants: '包含子部門',
    no_members: '沒有符合的成員。',
    all_members: '全部成員',
    all_departments: '全部部門',
    edit_member: '編輯部門歸屬',
    add_child: '新增子部門',
    expand_department: '展開{{name}}',
    collapse_department: '收合{{name}}',
    title: '部門',
    description: '管理目前組織的部門及成員歸屬。',
    create: '新增部門',
    edit: '編輯部門',
    name: '部門名稱',
    parent: '上層部門',
    root: '無上層部門',
    id: '部門 ID',
    members: '成員部門歸屬',
    member_id: '成員使用者 ID',
    primary: '主要部門',
    none: '未設定',
    assignments: '部門歸屬記錄',
    no_assignments: '尚無部門歸屬記錄。',
    assignment_hint: '指派本機部門，可設定一個主要部門。通訊錄同步的歸屬由來源維護。',
    empty: '尚無部門。',
    readonly: '你可以檢視部門及自己的歸屬。如需變更，請聯絡組織管理員。',
    load_error: '載入失敗，請重試。',
    mutation_error: '儲存失敗，請檢查權限、成員歸屬及部門階層。',
    loading: '載入中…',
    synced: '通訊錄同步',
    choose: '搜尋部門',
    organizations_title: '組織與部門',
    organizations_description: '選擇組織，檢視或管理其部門。',
    no_organizations: '你尚未加入組織，請聯絡組織管理員。',
    organization: '目前組織',
    choose_organization: '請選擇組織',
    delete_title: '刪除部門',
    delete_description: '確定刪除「{{name}}」？請先移走此部門的成員及子部門。',
};
export default Object.freeze(departments);
